import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-424a1b52"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "square" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.letters, (letter, index) => {
      return (_openBlock(), _createElementBlock("span", {
        class: "text",
        key: `${index}`
      }, _toDisplayString(letter), 1))
    }), 128))
  ]))
}